(function () {
    const header = document.querySelector('#header-group');
    let lastScrollY = window.scrollY;
    let ticking = false;

    function onScroll() {
    const currentScrollY = window.scrollY;

    if (currentScrollY < lastScrollY && lastScrollY - currentScrollY > 5) {
        // scroll up
        header.classList.add('scrolled-past-header');
    } else if (currentScrollY > lastScrollY && currentScrollY - lastScrollY > 5) {
        // scroll down
        header.classList.remove('scrolled-past-header');
    }

    lastScrollY = currentScrollY;
    ticking = false;
    }

    window.addEventListener('scroll', function () {
    if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
    }
    });
})();

(function () {
  var card = document.querySelector('.sticky-add-to-cart__bar');
  if (!card) return;

  function mainForm() {
    return Array.prototype.find.call(
      document.querySelectorAll('product-form-component'),
      function (f) { return !card.contains(f); }
    );
  }

  function updateVisibility() {
    var vh = window.innerHeight || document.documentElement.clientHeight;

    var mf = mainForm(), atc = mf && mf.querySelector('button[name="add"]');
    var atcVisible = false;
    if (atc) {
      var ra = atc.getBoundingClientRect();
      atcVisible = ra.bottom > 0 && ra.top < vh;
    }

    var footer = document.querySelector('.nk-footer-wrapper');
    var footerReached = footer ? (footer.getBoundingClientRect().top < vh) : false;

    card.classList.toggle('is-hidden', atcVisible || footerReached);
  }
  updateVisibility();
  window.addEventListener('scroll', updateVisibility, { passive: true });
  window.addEventListener('resize', updateVisibility, { passive: true });
})();


class NkThumbnailNav extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector('.slideshow-controls__thumbnails-container');
    this.prevButton = this.querySelector('.nk-thumbnail-nav__arrow--prev');
    this.nextButton = this.querySelector('.nk-thumbnail-nav__arrow--next');
    this.vertical = this.dataset.scrollMode === 'vertical';

    if (!this.scroller || !this.prevButton || !this.nextButton) return;

    this.prevButton.addEventListener('click', this.handlePrev);
    this.nextButton.addEventListener('click', this.handleNext);
    this.scroller.addEventListener('scroll', this.updateArrows, { passive: true });

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(this.updateArrows);
      this.resizeObserver.observe(this.scroller);
      this.resizeObserver.observe(this);
    } else {
      window.addEventListener('resize', this.updateArrows, { passive: true });
    }

    // Thumbnail set can change on variant update (content is replaced), recheck overflow.
    this.mutationObserver = new MutationObserver(this.updateArrows);
    this.mutationObserver.observe(this.scroller, { childList: true, subtree: true });

    this.updateArrows();
  }

  disconnectedCallback() {
    this.prevButton?.removeEventListener('click', this.handlePrev);
    this.nextButton?.removeEventListener('click', this.handleNext);
    this.scroller?.removeEventListener('scroll', this.updateArrows);
    this.resizeObserver?.disconnect();
    this.mutationObserver?.disconnect();
    window.removeEventListener('resize', this.updateArrows);
  }

  get scrollAmount() {
    if (!this.scroller) return 0;
    const visible = this.vertical ? this.scroller.clientHeight : this.scroller.clientWidth;
    // Scroll by ~80% of the visible area so a sliver of context stays in view.
    return Math.max(Math.round(visible * 0.8), 100);
  }

  handlePrev = () => {
    if (!this.scroller) return;
    const amount = -this.scrollAmount;
    this.scroller.scrollBy(
      this.vertical ? { top: amount, behavior: 'smooth' } : { left: amount, behavior: 'smooth' }
    );
  };

  handleNext = () => {
    if (!this.scroller) return;
    const amount = this.scrollAmount;
    this.scroller.scrollBy(
      this.vertical ? { top: amount, behavior: 'smooth' } : { left: amount, behavior: 'smooth' }
    );
  };

  updateArrows = () => {
    if (!this.scroller || !this.prevButton || !this.nextButton) return;

    const scrollPos = this.vertical ? this.scroller.scrollTop : this.scroller.scrollLeft;
    const scrollSize = this.vertical ? this.scroller.scrollHeight : this.scroller.scrollWidth;
    const clientSize = this.vertical ? this.scroller.clientHeight : this.scroller.clientWidth;

    const hasOverflow = scrollSize - clientSize > 1;
    this.toggleAttribute('overflowing', hasOverflow);

    if (!hasOverflow) {
      this.prevButton.hidden = true;
      this.nextButton.hidden = true;
      return;
    }

    // scrollLeft can be fractional, allow a 1px tolerance at each end.
    const atStart = scrollPos <= 1;
    const atEnd = scrollPos >= scrollSize - clientSize - 1;

    this.prevButton.hidden = false;
    this.nextButton.hidden = false;
    this.prevButton.disabled = atStart;
    this.nextButton.disabled = atEnd;
  };
}

if (!customElements.get('nk-thumbnail-nav')) {
  customElements.define('nk-thumbnail-nav', NkThumbnailNav);
}

// <!----- Thumbnails Arrow Code End ----->//
